<template>
  <lu-vbox lu-flex class="app-container">

    <lu-item>
    <PageHeader :title='$t("Roles")' :hasReload='true' :hasDownLoad='true' @reload='reload'/>
    </lu-item>

    <lu-vbox class="searchBox">
      <lu-hbox class='searchDivTitle pad-in-5' lu-vcenter lu-click @click='searchExpanded=!searchExpanded'>
        <lu-item lu-click class="el-icon-arrow-right blc-icon" style='font-size:0.85rem;' :class='searchExpanded ? "isActive" : ""'  />
        <lu-item>{{ $t('search.search') }} </lu-item>
      </lu-hbox>

      <template v-if='searchExpanded'>
        <el-form :model='formQuery' ref="formQuery" label-width="150px" lu-flex lu-flex-wrap sclass='lu-hbox'>
          <lu-vbox lu-flex-wrap class='lu-hbox'>
            <el-form-item :label="$t('search.label')" prop="label" class='mar-r-20'>
              <el-input :placeholder="$t('search.label')" v-model="formQuery.label" clearable @keyup.enter.native="search"/>
            </el-form-item>
          </lu-vbox>
        </el-form>

        <lu-hbox lu-hcenter class='pad-in-5 mar-t-10 mar-b-10'>
          <lu-item><el-button icon="el-icon-search" @click="handleSearch('formQuery')">{{ $t('action.search') | upperCase }}</el-button></lu-item>
          <lu-item><el-button icon="el-icon-close"  @click="handleCancel('formQuery')">{{ $t('action.cancel') | upperCase }}</el-button></lu-item>
          <lu-item><el-button icon="el-icon-edit"   v-permission='["adminRoleEdit"]' @click="handleCreate('formQuery')">{{ $t('action.create')| upperCase }}</el-button></lu-item>
          <!--
            <el-checkbox v-model="showReviewer" class="filter-item" style="margin-left:15px;" @change="tableKey=tableKey+1">{{ $t('table.reviewer') }}</el-checkbox>
            <el-button sv-waves :loading="downloadLoading" class="filter-item" type="primary" icon="el-icon-download" @click="handleDownload">{{ $t('table.export') }}</el-button>
          -->
        </lu-hbox>
      </template>
    </lu-vbox>

    <!-- <eltable border : set border -->
<!--<el-scrollbar wrap-class="scrollbar-wrapper">-->
  <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
    <el-table
      v-loading="listLoading"
      class='table'
      :data="dataList"
      fit
      striped
      highlight-current-row
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange">
    >
      <el-table-column
        type="selection"
        align='center'
        width="50"
        :selectable='selectableRow'
      />

      <el-table-column :label="$t('table.id')" prop="roleId" sortable align="center" width="65">
        <template slot-scope="scope">
          <span>{{ scope.row.roleId }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Label')" sortable prop='label' align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.label }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Status')" sortable prop='status' align='center' >
        <template slot-scope="scope">
            <el-tag style='width:100px;' size="mini" :type="scope.row.status | statusFilter" >
              <i :class="statusActiveName(scope.row.status)" style='margin-right: 5px;' />
                {{ scope.row.status | statusLabel }}
            </el-tag>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Actions')" align="center" width="150" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <lu-hbox lsu-hcenter slu-vcenter cslass='pad-in-5'>
            <el-button size="mini" class='icon' :icon="$acl.isAllowed('adminRoleEdit') ? 'el-icon-edit success' : 'el-icon-view success'"  @click='handleEdit(scope.row)'/>
            <el-button size="mini" class='icon' icon="el-icon-delete error"  @click='handleDelete([{roleId: scope.row.roleId}])' v-if='scope.row.isUsed === 0 && $acl.isAllowed("adminRoleEdit")'/>
          </lu-hbox>
        </template>
      </el-table-column>
    </el-table>



  </lu-scroll-area>

    <pagination v-show="totalCount>0" :total="totalCount" :page="currentPage" :limit="pageSize"
      :hasDelete='multipleSelection.length>0'
      @deleteSelectedItem="deleteSelectedItem"
      @pagination="getPageFromPagination" />

  </lu-vbox>
</template>

<script>
import BaseController from '@/controllers/BaseController'
import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import { parseTime } from '@/utils'
import roleMixin from './mixin'
import Pagination from '@/components/Pagination'
import PageHeader from '@/components/PageHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'adminRole',
  extends: BaseController,
  mixins: [ roleMixin ],
  components: { Pagination, PageHeader, LuVbox, LuHbox, LuItem, LuScrollArea },
  filters: {
    statusLabel(status) {
      return status === 1 ? 'Active' : 'Inactive'
    },
    statusFilter(status) {
      return status === 1 ? 'success' : 'warning'
    },
    upperCase(str) {
      return str.toUpperCase()
    }
  },
  computed : {
    ...mapGetters( ['pageSize'] )
  },
  data() {
    return {
      searchExpanded: true,
      dataList: null,
      listLoading: true,
      conditions: [],
      order: '',
      multipleSelection: [],
      downloadLoading: false,
      formQuery: {
        label: undefined
      }
    }
  },
  created() {
    this.getPage()
  },
  methods: {
    selectableRow (row) {
      return row.isUsed === 0
    },
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'odd-row';
      } else {
        return 'even-row';
      }
    },
    reload () {
      this.getPage(this.currentPage)
    },
    deleteSelectedItem () {
      let cond = this.multipleSelection.map(item => {
        return { roleId: item.roleId }
      })
      this.handleDelete(cond)
    },
    setCondition() {
      this.conditions = []
      if (this.formQuery.label) this.conditions.push({ 'field name': 'label', operator: 'like', value: [ '%' + this.formQuery.label + '%' ] })
    },
    getPageFromPagination(val) {
      this.currentPage = val.page
      this.getPage(this.currentPage)
    },
    getPage(page) {
      this.listLoading = true
      this.setCondition()
      this.searchData(
        'searchUserRole',
        page,
        this.conditions,
        null,
        { },
        () => {
          return true
        },
        function () {
          this.resultExpanded = true
          this.listLoading = false
        }.bind(this),
        'roleList',
        this.formQuery
      )
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSearch(formName) {
      if (this.$refs[formName].validate()) {
        this.getPage(1)
      }
    },
    sortChange(data) {
      const { prop, order } = data
      this.order = prop + ' ' + (order === 'ascending' ? 'ASC' : 'DESC')
      this.getPage(this.currentPage)
    },
    handleCancel (formName) {
      this.reset()
      this.conditions = []
      this.$refs[formName].resetFields()
      this.resultExpanded = false
      this.getPage(this.currentPage)
    },
    handleEdit (row) {
      let { params, meta } = this.$route
      let title = (meta && meta.title) ? meta.title + ':' + row.label : row.label
      let routePage = {
        fullpath: '/admin/role/edit',
        name: 'adminRoleEdit',
        meta: meta,
        title: title,
        params: Object.assign({ recordId: row.roleId, recordLabel: row.label },params)
      }

      routePage.params = Object.assign({ recordId: row.roleId, recordLabel: row.label }, this.$route.params)
      return this.viewEdit(routePage, false, true, false, this.dataList.map(c => {
        return {
          id: c.roleId,
          label: c.label
        }
      }))
    },
    handleCreate() {
      let routePage = { fullpath: '/admin/role/edit', name: 'adminRoleEdit', params: { } }
      return this.viewEdit(routePage, true, true, false, [])
    },
    handleUpdate(row) {
      this.id = row.roleId
    },
    handleDownload() {
      this.downloadLoading = true
      /*
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['timestamp', 'title', 'type', 'importance', 'status']
        const filterVal = ['timestamp', 'title', 'type', 'importance', 'status']
        const data = this.formatJson(filterVal, this.dataList)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'table-list'
        })
        this.downloadLoading = false
      })
      */
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
    statusActiveName (type) {
      if (type === 1) return 'el-icon-success'
      else if (type === 4 || type === 5) return 'el-icon-loading'
      else return 'el-icon-check'
    }
  }
}
</script>


<style>

</style>